require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./doc-2-and-more.json") })
        }
      }, "path---doc-2-and-more");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---doc-2-and-more!./.cache/json/doc-2-and-more.json
// module id = 381
// module chunks = 231608221292675